import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

interface StageAuthProps {
  children: React.ReactNode;
}

// Credenciales para el ambiente de staging
const STAGING_CREDENTIALS = {
  username: 'ti_staging',
  password: 'trusted2024'
};

// Verificar si estamos en el ambiente de staging
const isStaging = window.location.hostname === 'dev.trustedinterpreters.com';

export const StageAuth: React.FC<StageAuthProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Verificar si ya está autenticado en sessionStorage
    const authStatus = sessionStorage.getItem('stageAuth');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  // Si no estamos en staging, renderizar el contenido directamente
  if (!isStaging) {
    return <>{children}</>;
  }

  // Si ya está autenticado, renderizar el contenido
  if (isAuthenticated) {
    return <>{children}</>;
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    
    const formData = new FormData(e.currentTarget);
    const username = formData.get('username') as string;
    const password = formData.get('password') as string;

    if (
      username === STAGING_CREDENTIALS.username &&
      password === STAGING_CREDENTIALS.password
    ) {
      // Guardar el estado de autenticación en sessionStorage
      sessionStorage.setItem('stageAuth', 'true');
      setIsAuthenticated(true);
    } else {
      setError('Credenciales inválidas. Por favor, intente nuevamente.');
    }
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Staging - Trusted Interpreters</title>
      </Helmet>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          width: '100%',
          maxWidth: '400px'
        }}>
          <h2 style={{ 
            marginBottom: '1.5rem', 
            color: '#025f99',
            textAlign: 'center' 
          }}>
            Ambiente de Staging
          </h2>
          <p style={{ 
            marginBottom: '1.5rem', 
            color: '#666',
            textAlign: 'center' 
          }}>
            Por favor, ingrese sus credenciales para acceder al sitio.
          </p>
          {error && (
            <div style={{ 
              padding: '10px', 
              backgroundColor: '#ffebee', 
              color: '#c62828', 
              borderRadius: '4px',
              marginBottom: '1rem',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem' }}>
              <label 
                htmlFor="username" 
                style={{ 
                  display: 'block', 
                  marginBottom: '0.5rem',
                  fontWeight: 'bold'
                }}
              >
                Usuario
              </label>
              <input
                id="username"
                type="text"
                name="username"
                placeholder="Ingrese su usuario"
                style={{
                  padding: '0.75rem',
                  width: '100%',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  boxSizing: 'border-box'
                }}
                required
              />
            </div>
            <div style={{ marginBottom: '1.5rem' }}>
              <label 
                htmlFor="password" 
                style={{ 
                  display: 'block', 
                  marginBottom: '0.5rem',
                  fontWeight: 'bold'
                }}
              >
                Contraseña
              </label>
              <input
                id="password"
                type="password"
                name="password"
                placeholder="Ingrese su contraseña"
                style={{
                  padding: '0.75rem',
                  width: '100%',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  boxSizing: 'border-box'
                }}
                required
              />
            </div>
            <button
              type="submit"
              style={{
                padding: '0.75rem 1rem',
                backgroundColor: '#025f99',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                width: '100%',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}
            >
              Iniciar Sesión
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default StageAuth; 